import { render, staticRenderFns } from "./16.vue?vue&type=template&id=235655be&scoped=true&"
import script from "./16.vue?vue&type=script&lang=js&"
export * from "./16.vue?vue&type=script&lang=js&"
import style0 from "./16.vue?vue&type=style&index=0&id=235655be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235655be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235655be')) {
      api.createRecord('235655be', component.options)
    } else {
      api.reload('235655be', component.options)
    }
    module.hot.accept("./16.vue?vue&type=template&id=235655be&scoped=true&", function () {
      api.rerender('235655be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/16.vue"
export default component.exports